import localStorageUtil from '$/common/utils/localStorageUtil';
import { resolveAgentTeamDownloadUrl } from '$/domains/teamAgent/teamAgentService';
import type { AigcWaterMarkSwitch } from '$/domains/teamAgent/type';

export type AigcWaterMarkState = '0' | '1';

/**
 * 判断当前媒体类型是否需要接入“无品牌水印直出”会员引导。
 */
export function isNoBrandWatermarkGuideMedia(mediaType?: string): mediaType is 'image' | 'video' {
  return mediaType === 'image' || mediaType === 'video';
}

/**
 * 将设置面板里的 AIGC 水印开关转换为后端约定值；未设置时按默认开启处理。
 */
export function getAigcWaterMarkSwitch(): AigcWaterMarkSwitch {
  if (typeof window === 'undefined') return 1;
  return localStorageUtil.getItem('RoboneoDownloadHasWatermark') === '0' ? 2 : 1;
}

/**
 * 读取当前 AIGC 水印状态；未设置时保持产品默认开启。
 */
export function getAigcWaterMarkState(): AigcWaterMarkState {
  return getAigcWaterMarkSwitch() === 1 ? '1' : '0';
}

/**
 * 将旧水印弹窗状态转换为后端下载解析接口的 AIGC 开关。
 */
export function getAigcWaterMarkSwitchByState(state: AigcWaterMarkState): AigcWaterMarkSwitch {
  return state === '1' ? 1 : 2;
}

/**
 * 解析会员无品牌水印下载地址。
 * TODO: 水印接口完成后，在这里根据素材标识请求/替换真正的无品牌水印成品地址。
 */
export function resolveNoBrandWatermarkDownloadUrl({
  url,
}: {
  url: string;
  watermarkUrl?: string;
}): string {
  return url;
}

/**
 * 下载前请求后端解析最终 URL；接口异常时按产品要求降级使用当前原始下载地址。
 */
export async function resolveNoBrandWatermarkDownloadUrlByApi({
  url,
  watermarkUrl,
  aigcWaterMarkSwitch,
  fallbackUrl,
}: {
  url: string;
  watermarkUrl?: string;
  aigcWaterMarkSwitch?: AigcWaterMarkSwitch;
  fallbackUrl?: string;
}): Promise<string> {
  const resolvedFallbackUrl = fallbackUrl || url || watermarkUrl || '';
  if (!resolvedFallbackUrl) return resolvedFallbackUrl;

  try {
    const result = await resolveAgentTeamDownloadUrl({
      media_url: url || undefined,
      media_url_by_water_mark: watermarkUrl || undefined,
      aigc_watermark_switch: aigcWaterMarkSwitch ?? getAigcWaterMarkSwitch(),
    });
    return result.download_url || resolvedFallbackUrl;
  } catch {
    return resolvedFallbackUrl;
  }
}
